<footer>
    <div class="layout footer-layout">
        <div>©2025 Македонски Телеком </div>
    </div>
</footer>